import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

interface IValue {
  angle: number;
  color: string;
  label: string;
}

interface IProps {
  options?: any;
  data: Array<IValue>;
}

const DonutChart: React.FC<IProps> = ({ options, data }) => {
  const formattedData = useMemo(() => {
    if (!data) return {};
    const series: Array<any> = [];
    const labels: Array<string> = [];
    const colors: Array<string> = [];
    data.forEach(value => {
      series.push(value.angle);
      labels.push(value.label);
      colors.push(value.color);
    });
    return {
      series,
      labels,
      colors,
    };
  }, data);

  return (
    <>
      <Chart
        series={formattedData.series}
        options={{
          labels: formattedData.labels,
          colors: formattedData.colors,
          ...options,
        }}
        type="donut"
      />
    </>
  );
};

export default DonutChart;
